import React, { SVGProps, memo } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { Theme, useTheme } from '@mui/material/styles';

interface Props extends SvgIconProps {
  alt?: boolean;
  dark?: boolean;
}

function DownloadDocumentIcon({ dark = false, ...props }: Props) {
  const { palette }: Theme = useTheme();

  const contrastForeground = dark ? palette.secondary.lightest : palette.secondary.main;

  const foreground = contrastForeground;

  const stroke: SVGProps<SVGPathElement> = {
    stroke: foreground,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeWidth: 1.75,
  };

  return (
    <SvgIcon {...props} fill="none" viewBox="0 0 20 24">
      <path
        {...stroke}
        d="M13.2 1.22H5.42A4.46 4.46 0 00.96 5.57V18.1a4.44 4.44 0 004.47 4.53h9.32c2.4 0 4.35-2.13 4.35-4.53V7.38l-5.9-6.16z"
        clipRule="evenodd"
        fill="none"
      />
      <path {...stroke} fill="none" d="M12.89 1.2v3.4a3 3 0 003 3h3.2" />
      <path {...stroke} fill="none" d="M9.58 16.68V9.01" />
      <path {...stroke} fill="none" d="M6.27 13.36l3.31 3.32 3.31-3.32" />
    </SvgIcon>
  );
}

export default memo(DownloadDocumentIcon);
